import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { detailsData } from "./details";

const SuggestedWrapsTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  selectedRow,
  can_create,
  options,
}) => {
  const { t } = useTranslation();
  const [supportedLang] = useState("en");
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const wrappable_type = [
    { id: 1, name: t("wrappers_suggested_wraps.cart") },
    { id: 2, name: t("wrappers_suggested_wraps.cart_item") },
  ];
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("wrappers_suggested_wraps.details"),
            data: {
              images: [{ id: 0, img: details?.image }],
              list: detailsData({ data: details, t }),
            },
          }}
          table={{
            list: data, // data
            listTitle: t("wrappers_suggested_wraps.title"), //title
            createBtnTitle: can_create && t("wrappers_suggested_wraps.add"), // action
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              { accessor: "image", Header: t("common.image"), sort: true },
              {
                accessor: "localized_data.en.name",
                Header: t("wrappers_suggested_wraps.name_en"),
                sort: true,
              },
              {
                accessor: "localized_data.ar.name",
                Header: t("wrappers_suggested_wraps.name_ar"),
                sort: true,
              },
              {
                accessor: "cost",
                Header: t("wrappers_suggested_wraps.price"),
                sort: true,
              },
              {
                accessor: "cost_after_discount",
                Header: t("wrappers_suggested_wraps.price_after_discount"),
                sort: true,
              },

              { accessor: "Actions", Header: t("common.action_actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: t(
              "wrappers_suggested_wraps.search_placeholder",
            ),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list ...
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            // lw mafesh id add mafesh values -------- lw fe id yb2a edit values
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure(wrappable_type, options, t),
            validationSchema: validationSchema(),
            deleteFun: deleteFun,
            title: id
              ? t("wrappers_suggested_wraps.edit")
              : t("wrappers_suggested_wraps.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default SuggestedWrapsTemplate;
